import React from "react";
import { FieldError, UseFormRegister } from "react-hook-form";

interface FormInputProps {
  label: string;
  name: string;
  type?: string;
  register: ReturnType<UseFormRegister<any>>;
  error?: FieldError;
  disabled?: boolean;
  className?: string;
  inputMode?: "numeric" | "decimal";
  required?: boolean;
}

const FormInput: React.FC<FormInputProps> = ({
  label,
  name,
  type = "text",
  register,
  error,
  disabled = false,
  className = "",
  inputMode,
  required
}) => {
  // Chặn nhập ký tự không hợp lệ nếu là số
  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    // Chỉ cho phép số, dấu chấm, dấu trừ đầu dòng
    if (!/[0-9.\-]/.test(e.key) || (e.key === '-' && e.currentTarget.selectionStart !== 0)) {
      e.preventDefault();
    }
  };

  return (
    <div className={`${className}`}>
      <label className="block text-sm font-medium mb-1 text-gray-700" htmlFor={name}>{label} {required && <span className="text-red-500">*</span>}</label>
      <input
        id={name}
        type={type}
        inputMode={inputMode}
        className={`${type === "checkbox" ? "" : "w-full"} border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400`}
        {...register}
        disabled={disabled}
        // onKeyPress={inputMode === "decimal" || inputMode === "numeric" ? handleKeyPress : undefined}
      />
      {error && (
        <span className="text-red-500 text-xs mt-1 block">{error.message as string}</span>
      )}
    </div>
  );
};

export default FormInput;
